/* Gimbal Flow — minimal JS: mobile menu, gallery, quantity, live variants, sticky buy bar. */
(function () {
  'use strict';

  // Menú lateral
  var toggle = document.querySelector('[data-menu-toggle]');
  var menu = document.querySelector('[data-mobile-menu]');
  var overlay = document.querySelector('[data-drawer-overlay]');
  var closeBtn = document.querySelector('[data-menu-close]');
  if (toggle && menu) {
    var setMenu = function (open) {
      menu.classList.toggle('is-open', open);
      if (overlay) overlay.classList.toggle('is-open', open);
      document.body.classList.toggle('menu-open', open);
      toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
      if (open && closeBtn) closeBtn.focus();
      if (!open) toggle.focus();
    };
    toggle.addEventListener('click', function () { setMenu(!menu.classList.contains('is-open')); });
    if (closeBtn) closeBtn.addEventListener('click', function () { setMenu(false); });
    if (overlay) overlay.addEventListener('click', function () { setMenu(false); });
    menu.addEventListener('click', function (e) {
      if (e.target.closest('a')) { menu.classList.remove('is-open'); if (overlay) overlay.classList.remove('is-open'); document.body.classList.remove('menu-open'); toggle.setAttribute('aria-expanded', 'false'); }
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && menu.classList.contains('is-open')) setMenu(false);
    });
  }

  // Product gallery thumbnails
  var main = document.querySelector('[data-main-img]');
  document.querySelectorAll('[data-thumb]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      if (main) {
        main.src = btn.getAttribute('data-src');
        main.removeAttribute('srcset');
      }
      document.querySelectorAll('[data-thumb]').forEach(function (b) {
        b.setAttribute('aria-current', b === btn ? 'true' : 'false');
      });
    });
  });

  // Quantity stepper
  document.querySelectorAll('[data-qty]').forEach(function (wrap) {
    var input = wrap.querySelector('input');
    wrap.querySelectorAll('button').forEach(function (b) {
      b.addEventListener('click', function () {
        var step = parseInt(b.getAttribute('data-step'), 10) || 0;
        input.value = Math.max(1, (parseInt(input.value, 10) || 1) + step);
      });
    });
  });

  // Product page: live variants, price and availability
  var root = document.querySelector('[data-product-root]');
  if (root) {
    var buyBtn = root.querySelector('[data-buy-button]');
    var stickyBtn = document.querySelector('[data-sticky-button]');
    var bar = document.querySelector('[data-sticky-buy]');
    var form = document.getElementById('ProductForm');
    var addText = root.getAttribute('data-add-text') || '';
    var soldText = root.getAttribute('data-soldout-text') || '';

    var fmt = function (cents) {
      try {
        return new Intl.NumberFormat(document.documentElement.lang || undefined, {
          style: 'currency', currency: root.getAttribute('data-currency') || 'EUR'
        }).format(cents / 100);
      } catch (e) { return (cents / 100).toFixed(2); }
    };

    var setAvailability = function (available) {
      if (buyBtn) { buyBtn.disabled = !available; buyBtn.textContent = available ? addText : soldText; }
      if (stickyBtn) { stickyBtn.disabled = !available; stickyBtn.textContent = available ? addText : soldText; }
    };

    var dataEl = root.querySelector('[data-variants]');
    if (dataEl) {
      var variants = [];
      try { variants = JSON.parse(dataEl.textContent); } catch (e) { variants = []; }
      var selects = root.querySelectorAll('[data-option-select]');
      var idInput = root.querySelector('[data-variant-id]');
      var priceEl = root.querySelector('[data-price]');
      var compareEl = root.querySelector('[data-compare]');
      var badgeEl = root.querySelector('[data-badge]');
      var stickyPrice = document.querySelector('[data-sticky-price]');

      selects.forEach(function (sel) {
        sel.addEventListener('change', function () {
          var chosen = Array.prototype.map.call(selects, function (s) { return s.value; });
          var match = variants.find(function (v) {
            return v.options.every(function (o, i) { return o === chosen[i]; });
          });
          if (!match) { setAvailability(false); return; }

          if (idInput) idInput.value = match.id;
          if (priceEl) priceEl.textContent = fmt(match.price);
          if (stickyPrice) stickyPrice.textContent = fmt(match.price);
          var onSale = match.compare_at_price && match.compare_at_price > match.price;
          if (compareEl) { compareEl.hidden = !onSale; if (onSale) compareEl.textContent = fmt(match.compare_at_price); }
          if (badgeEl) {
            badgeEl.hidden = !onSale;
            if (onSale) badgeEl.textContent = '-' + Math.round((match.compare_at_price - match.price) * 100 / match.compare_at_price) + '%';
          }
          if (main && match.featured_image && match.featured_image.src) {
            main.src = match.featured_image.src;
            main.removeAttribute('srcset');
          }
          setAvailability(match.available);

          try {
            var url = new URL(window.location.href);
            url.searchParams.set('variant', match.id);
            window.history.replaceState({}, '', url);
          } catch (e) { /* ignore */ }
        });
      });
    }

    // Sticky buy bar (mobile): appears once the main button leaves the screen, and adds to cart directly
    if (buyBtn && bar && 'IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        bar.classList.toggle('is-visible', !entries[0].isIntersecting);
      }).observe(buyBtn);
    }
    if (stickyBtn && form && buyBtn) {
      stickyBtn.addEventListener('click', function () {
        if (typeof form.requestSubmit === 'function') form.requestSubmit(buyBtn);
        else buyBtn.click();
      });
    }
  }
})();
